'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { ScoreDoughnut } from '../../charts/score-doughnut/ScoreDoughnut';
import type { AnswerRateType } from '../multiple-choice-question-answer/MultipleChoiceQuestionAnswer.types';
import { TimeLimit } from './TimeLimit';

import styles from './ScoreSummary.module.scss';

type ScoreSummaryProps = BaseComponentProps & {
  score: number;
  answerRate: AnswerRateType;
  /** How long the attempt took, in seconds. */
  elapsedTime: number;
  cutout?: string;
};

/** How an attempt went: the mark it earned and the time it took to earn it. */
function ScoreSummary({
  style,
  className,
  score,
  answerRate,
  elapsedTime,
  cutout,
}: ScoreSummaryProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      <ScoreDoughnut score={score} answerRate={answerRate} cutout={cutout} />
      <TimeLimit seconds={elapsedTime} className={styles['time-limit']} />
    </div>
  );
}

export { ScoreSummary };
